<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-md-4">
          <div class="card-group mb-4">
            <div class="card p-4">
              <div class="card-body">
                <h1>{{$t('LOGIN')}}</h1>
                <p class="text-muted">{{$t('LOGINTOYOURACCOUNT')}}</p>
                <div class="input-group mb-3">
                  <span class="input-group-addon"><icon icon="user"></icon></span>
                  <input type="text" v-model="username" v-on:keyup.13="login" class="form-control" v-bind:placeholder="$t('USERNAME')">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><icon icon="lock"></icon></span>
                  <input type="password" v-model="password" v-on:keyup.13="login" class="form-control" v-bind:placeholder="$t('PASSWORD')">
                </div>
                <div class="row">
                  <div class="col-12">
                    <p class="bg-danger" v-if="loginResponse.error && loginResponse.notice">{{loginResponse.notice}}</p>
                  </div>
                  <div class="col-6">
                    <button type="button" v-on:click.prevent="login" class="btn btn-primary px-4">{{$t('LOGIN')}}</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Login',
  data: function()
  {
    return {username: '', password: ''}
  },
  methods:
  {
    ...mapActions({
      actLogin: 'login'
    }),
    login: function(bvEvt)
    {
      bvEvt.preventDefault();
      this.actLogin({username: this.username, password: this.password});
    }
  },
  computed:
  {
    ...mapGetters([
      'loginResponse'
    ])
  }
}
</script>
